<template>
  <v-container>
    <v-row justify="center">
      <v-card width="800" flat class="bg1 pa-5" :disabled="loading">
        <v-card-title>Feedback</v-card-title>
        <v-card-subtitle>
          Cuentanos tu experiencia con la aplicacion
        </v-card-subtitle>
        <v-divider />
        <v-card-text>
          <v-form>
            <v-row>
              <v-col md="6" cols="12">
                <v-text-field
                  outlined
                  color="yellow darken-2"
                  label="Nombre de Usuario"
                  placeholder="usuario"
                />
              </v-col>
              <v-col md="6" cols="12">
                <v-text-field
                  outlined
                  color="yellow darken-2"
                  label="Correo"
                  placeholder="example@example.com"
                />
              </v-col>
            </v-row>
            <v-textarea
              outlined
              color="yellow darken-2"
              label="Describe aqui tu experiencia"
              placeholder="..."
            />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="yellow darken-2"
                :block="!loading"
                outlined
                :disabled="loading"
                :loading="loading"
                @click="loading = !loading"
              >
                Enviar Reseña
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    form: {
      usuario: "",
      email: "",
      comentario: "",
    },
    loading: false,
  }),
};
</script>

<style scoped>
.bg1 {
  background: linear-gradient(
    -1.8deg,
    rgba(30, 30, 30, 1) 95%,
    rgba(251, 192, 45, 1) 96%
  ) !important;
}
</style>
